import { SignUp } from "@clerk/clerk-react";
import markGradient from "../brand/assets/mark-gradient.png";

// Full-page sign-up, shown to an invited proofer arriving from the invite email.
// Clerk's <SignUp/> automatically detects the `__clerk_ticket` query param (set on
// the invitation's redirect_url), so the email is pre-filled and a real Clerk
// account is created — no "user doesn't exist" dead-end. After sign-up the proofer
// is sent to My Work.
export function SignUpScreen() {
  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-brand">
          <img src={markGradient} width={44} height={44} alt="" aria-hidden="true" />
          <span className="auth-wordmark">MOCKINGBIRD</span>
        </div>
        <p className="auth-tag">You've been invited to proof. Create your account to see your work.</p>
        <SignUp
          routing="hash"
          signInUrl="/sign-in"
          fallbackRedirectUrl="/my-work"
          appearance={{
            variables: {
              colorPrimary: "#7c3aed",
              borderRadius: "12px",
              fontFamily: "'Hanken Grotesk', system-ui, sans-serif",
            },
            elements: {
              rootBox: "auth-clerk-root",
              card: "auth-clerk-card",
            },
          }}
        />
      </div>
      <div className="auth-foot muted">Invite-only beta · Mockingbird</div>
    </div>
  );
}
